import { LicenseLimits } from '@modules/leader/api/useGetLeaderSystemInfo';

export function useHasGuardAccess(
  limits: LicenseLimits | null | undefined,
  name: keyof LicenseLimits,
  value: number,
): boolean {
  if (limits === null) {
    return true;
  } // no limits, fail open
  const limit = limits?.[name] ?? null;

  if (limit === null) {
    return true; // unknown limit, fail open
  }

  if (value === null) {
    return true; // no value to check
  }

  return value <= limit;
}
